import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { Header, Footer } from '../components/landing';

const floatingIcons = [
  { src: '/images/cta-icons/ai.png' },
  { src: '/images/cta-icons/clipboard.png' },
  { src: '/images/cta-icons/infinity.png' },
  { src: '/images/cta-icons/globe.png' },
  { src: '/images/cta-icons/briefcase.png' },
  { src: '/images/cta-icons/robot.png' },
];

export default function ContactPage() {
  const [formData, setFormData] = useState({
    firstName: '',
    lastName: '',
    email: '',
    countryCode: 'US',
    phone: '',
    message: '',
  });
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [submitted, setSubmitted] = useState(false);

  const handleChange = (e) => {
    const { name, value, type, checked } = e.target;
    setFormData(prev => ({
      ...prev,
      [name]: type === 'checkbox' ? checked : value,
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setIsSubmitting(true);

    // Simulate form submission
    await new Promise(resolve => setTimeout(resolve, 1000));

    console.log('Form submitted:', formData);
    setSubmitted(true);
    setIsSubmitting(false);
  };

  return (
    <div className="min-h-screen bg-white">
      <Header />

      <main className="pt-24">
        {/* Contact Form Section */}
        <section className="py-16 px-6 lg:px-8">
          <div className="mx-auto max-w-7xl">
            <div className="grid lg:grid-cols-2 gap-12 lg:gap-20 items-start">
              {/* Left side - Form */}
              <div>
                <h1 className="font-jakarta text-4xl sm:text-5xl font-bold text-gray-900 mb-4">
                  Contact us
                </h1>
                <p className="text-gray-600 font-manrope text-lg mb-8">
                  Our team would love to hear from you.
                </p>

                {submitted ? (
                  <div className="bg-green-50 border border-green-200 rounded-2xl p-8 text-center">
                    <div className="w-16 h-16 bg-green-100 rounded-full flex items-center justify-center mx-auto mb-4">
                      <svg className="w-8 h-8 text-green-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M5 13l4 4L19 7" />
                      </svg>
                    </div>
                    <h3 className="font-jakarta text-xl font-bold text-gray-900 mb-2">Message sent!</h3>
                    <p className="text-gray-600 font-manrope">We'll get back to you as soon as possible.</p>
                  </div>
                ) : (
                  <form onSubmit={handleSubmit} className="space-y-6">
                    {/* Name fields */}
                    <div className="grid sm:grid-cols-2 gap-4">
                      <div>
                        <label htmlFor="firstName" className="block text-sm font-medium text-gray-900 mb-2 font-manrope">
                          First name
                        </label>
                        <input
                          type="text"
                          id="firstName"
                          name="firstName"
                          value={formData.firstName}
                          onChange={handleChange}
                          placeholder="First name"
                          required
                          className="block w-full rounded-xl border border-gray-300 px-4 py-3 text-gray-900 placeholder-gray-400 focus:outline-none focus:ring-2 focus:ring-cleona-500 focus:border-transparent font-manrope"
                        />
                      </div>
                      <div>
                        <label htmlFor="lastName" className="block text-sm font-medium text-gray-900 mb-2 font-manrope">
                          Last name
                        </label>
                        <input
                          type="text"
                          id="lastName"
                          name="lastName"
                          value={formData.lastName}
                          onChange={handleChange}
                          placeholder="Last name"
                          required
                          className="block w-full rounded-xl border border-gray-300 px-4 py-3 text-gray-900 placeholder-gray-400 focus:outline-none focus:ring-2 focus:ring-cleona-500 focus:border-transparent font-manrope"
                        />
                      </div>
                    </div>

                    {/* Email */}
                    <div>
                      <label htmlFor="email" className="block text-sm font-medium text-gray-900 mb-2 font-manrope">
                        Email
                      </label>
                      <input
                        type="email"
                        id="email"
                        name="email"
                        value={formData.email}
                        onChange={handleChange}
                        placeholder="admin@company.com"
                        required
                        className="block w-full rounded-xl border border-gray-300 px-4 py-3 text-gray-900 placeholder-gray-400 focus:outline-none focus:ring-2 focus:ring-cleona-500 focus:border-transparent font-manrope"
                      />
                    </div>

                    {/* Phone */}
                    <div>
                      <label htmlFor="phone" className="block text-sm font-medium text-gray-900 mb-2 font-manrope">
                        Phone number
                      </label>
                      <div className="flex">
                        <select
                          name="countryCode"
                          value={formData.countryCode}
                          onChange={handleChange}
                          className="rounded-l-xl border border-r-0 border-gray-300 px-3 py-3 text-gray-900 bg-gray-50 focus:outline-none focus:ring-2 focus:ring-cleona-500 focus:border-transparent font-manrope"
                        >
                          <option value="US">US</option>
                          <option value="UK">UK</option>
                          <option value="CA">CA</option>
                          <option value="AU">AU</option>
                          <option value="DE">DE</option>
                          <option value="FR">FR</option>
                        </select>
                        <input
                          type="tel"
                          id="phone"
                          name="phone"
                          value={formData.phone}
                          onChange={handleChange}
                          placeholder="+1 (555) 000-0000"
                          className="block w-full rounded-r-xl border border-gray-300 px-4 py-3 text-gray-900 placeholder-gray-400 focus:outline-none focus:ring-2 focus:ring-cleona-500 focus:border-transparent font-manrope"
                        />
                      </div>
                    </div>

                    {/* Message */}
                    <div>
                      <label htmlFor="message" className="block text-sm font-medium text-gray-900 mb-2 font-manrope">
                        Message
                      </label>
                      <textarea
                        id="message"
                        name="message"
                        value={formData.message}
                        onChange={handleChange}
                        rows={4}
                        placeholder="Leave us a message..."
                        required
                        className="block w-full rounded-xl border border-gray-300 px-4 py-3 text-gray-900 placeholder-gray-400 focus:outline-none focus:ring-2 focus:ring-cleona-500 focus:border-transparent font-manrope resize-none"
                      />
                    </div>

                    {/* Submit button */}
                    <button
                      type="submit"
                      disabled={isSubmitting}
                      className="w-full rounded-xl bg-cleona-600 px-6 py-4 text-base font-semibold text-white hover:bg-cleona-700 transition-colors font-manrope disabled:opacity-50 disabled:cursor-not-allowed"
                    >
                      {isSubmitting ? 'Sending...' : 'Send Message'}
                    </button>
                  </form>
                )}
              </div>

              {/* Right side - Image */}
              <div className="hidden lg:block">
                <div className="relative rounded-3xl overflow-hidden shadow-2xl">
                  <img
                    src="/images/contact/contact-hero.png"
                    alt="Contact us"
                    className="w-full h-[600px] object-cover"
                  />
                </div>
              </div>
            </div>
          </div>
        </section>

        {/* CTA Section */}
        <section className="py-16 px-6 lg:px-8">
          <div
            className="mx-auto max-w-6xl rounded-3xl py-20 px-8 relative overflow-hidden"
            style={{
              background: '#F4FBFC',
              boxShadow: '0px 20px 50px rgba(2, 5, 0, 0.08)',
            }}
          >
            <div className="text-center relative z-10">
              {/* Badge */}
              <div className="inline-flex items-center gap-2 rounded-pill bg-cleona-600 px-4 py-2 mb-6">
                <span className="text-white font-manrope font-semibold text-sm">Ready to Build</span>
                <span className="flex items-center justify-center w-6 h-6 rounded-full bg-white">
                  <svg className="w-3 h-3 text-cleona-600" fill="currentColor" viewBox="0 0 20 20">
                    <path fillRule="evenodd" d="M10.293 5.293a1 1 0 011.414 0l4 4a1 1 0 010 1.414l-4 4a1 1 0 01-1.414-1.414L12.586 11H5a1 1 0 110-2h7.586l-2.293-2.293a1 1 0 010-1.414z" clipRule="evenodd" />
                  </svg>
                </span>
              </div>

              {/* Heading */}
              <h2 className="font-jakarta text-4xl font-bold text-gray-900 sm:text-5xl mb-6">
                Ready to Build Your First<br />Smart Assistant™?
              </h2>

              {/* Subtext */}
              <p className="text-gray-600 font-manrope text-lg max-w-2xl mx-auto mb-10">
                Join organizations already using CLEONA to make their information clear, accessible, and always available.
              </p>

              {/* CTA Button */}
              <Link
                to="/admin/signup"
                className="inline-flex items-center gap-2 rounded-pill bg-cleona-600 px-8 py-4 text-lg font-semibold text-white hover:bg-cleona-700 transition-colors font-manrope shadow-lg hover:shadow-xl"
              >
                Start Building
                <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M17 8l4 4m0 0l-4 4m4-4H3" />
                </svg>
              </Link>
            </div>

            {/* Floating icons */}
            <div className="relative mt-12 h-48 md:h-64 w-full mx-auto flex justify-center">
              <div className="relative w-full max-w-4xl">
                {floatingIcons.map((item, index) => {
                  const totalIcons = floatingIcons.length;
                  const spacing = 100 / (totalIcons + 1);
                  const leftPercent = spacing * (index + 1);
                  const centerIndex = (totalIcons - 1) / 2;
                  const distanceFromCenter = Math.abs(index - centerIndex);
                  const maxDistance = centerIndex;
                  const arcHeight = (1 - (distanceFromCenter / maxDistance)) * 60;

                  return (
                    <div
                      key={index}
                      className="absolute"
                      style={{
                        left: `${leftPercent}%`,
                        top: `${arcHeight}px`,
                        transform: 'translateX(-50%)',
                      }}
                    >
                      <img
                        src={item.src}
                        alt=""
                        className="w-20 h-20 md:w-28 md:h-28 lg:w-32 lg:h-32 animate-bounce-slow"
                        style={{
                          animationDelay: `${index * 0.15}s`,
                          animationDuration: `${2.5 + index * 0.2}s`
                        }}
                      />
                    </div>
                  );
                })}
              </div>
            </div>
          </div>

          <style>{`
            @keyframes bounce-slow {
              0%, 100% { transform: translateY(0); }
              50% { transform: translateY(-10px); }
            }
            .animate-bounce-slow {
              animation: bounce-slow 3s ease-in-out infinite;
            }
          `}</style>
        </section>
      </main>

      <Footer />
    </div>
  );
}
